import { Loader2 } from "lucide-react";
import { useTranslate } from "ra-core";

import { assetMessage, type MessageSubject } from "./assetMessages";
import type { AssetDisplayState } from "./meetingAssets";

/**
 * The panel shown where an asset would be, saying why it is not there yet in
 * the shared wording. A spinner while it is still on its way.
 */
export const AssetPlaceholder = ({
  subject,
  state,
}: {
  subject: MessageSubject;
  state: AssetDisplayState;
}) => {
  const translate = useTranslate();
  // "available" with nothing to show happens only for a moment, between the
  // view row updating and the recordings refetch it triggers.
  const message = assetMessage(
    subject,
    state === "available" ? "processing" : state,
  );
  const moving =
    state === "processing" || state === "waiting" || state === "available";
  return (
    <div className="border rounded-lg h-full flex items-center justify-center text-muted-foreground text-sm p-4 text-center">
      <span className="flex items-center gap-2">
        {moving && <Loader2 className="size-4 animate-spin shrink-0" />}
        {message &&
          translate(message.key, { asset: translate(message.args.asset) })}
      </span>
    </div>
  );
};
